import { Wrench, RefreshCw } from 'lucide-react';
import { Button } from './ui/button';
import { useMaintenance } from '../../lib/MaintenanceContext';

interface MaintenanceScreenProps {
    message?: string;
}

export function MaintenanceScreen({ message }: MaintenanceScreenProps) {
    const { maintenanceMode, refresh } = useMaintenance();

    const displayMessage = message || maintenanceMode.message ||
        "Wysko wraca za moment. Aktualizujemy system - to może potrwać kilka/kilkanaście minut.";

    return (
        <div className="h-screen w-screen flex items-center justify-center bg-background relative overflow-hidden">
            {/* Background pattern matching the app */}
            <div className="bg-grid-pattern" />

            <div className="flex flex-col items-center gap-8 relative z-10 max-w-md px-6 text-center">
                {/* Icon */}
                <div className="relative">
                    <div className="absolute inset-0 bg-amber-500/20 rounded-full blur-xl animate-pulse" />
                    <div className="w-20 h-20 bg-card border border-amber-500/30 rounded-2xl flex items-center justify-center shadow-2xl relative">
                        <Wrench className="w-10 h-10 text-amber-500" />
                    </div>
                </div>

                {/* Title */}
                <h1 className="text-2xl font-bold tracking-tight">
                    Przerwa techniczna
                </h1>

                {/* Message */}
                <p className="text-muted-foreground text-lg leading-relaxed">
                    {displayMessage}
                </p>

                {/* Refresh button */}
                <Button
                    variant="outline"
                    onClick={refresh}
                    className="gap-2 mt-4"
                >
                    <RefreshCw className="w-4 h-4" />
                    Sprawdź ponownie
                </Button>

                {/* Animated dots */}
                <div className="flex gap-1.5 mt-4">
                    <div className="w-2 h-2 rounded-full bg-amber-500/60 animate-bounce [animation-delay:-0.3s]" />
                    <div className="w-2 h-2 rounded-full bg-amber-500/60 animate-bounce [animation-delay:-0.15s]" />
                    <div className="w-2 h-2 rounded-full bg-amber-500/60 animate-bounce" />
                </div>
            </div>
        </div>
    );
}
